export const className =
  'flex w-fit border-custom text-sm font-medium py-2 px-4 rounded-md disabled:opacity-50 disabled:cursor-not-allowed relative items-center'

export const classNameDanger =
  'bg-white dark:bg-black text-red-600 dark:text-red-500 border-gray-200 dark:border-gray-700 hover:bg-gray-200 dark:hover:bg-gray-700 hover:border-gray-700 dark:hover:border-gray-200 text-sm font-medium py-2 px-4 rounded-md disabled:opacity-50 disabled:cursor-not-allowed relative items-center border flex'

// @@TODO: Check value for z-index: z-10
export const className2 =
  'z-10 bg-white dark:bg-black text-black dark:text-white border-gray-200 dark:border-gray-700 hover:bg-gray-200 dark:hover:bg-gray-700 hover:border-gray-700 dark:hover:border-gray-200 text-sm font-medium py-2 px-4 rounded-md disabled:opacity-25 disabled:cursor-not-allowed relative items-center border'

export const className3 =
  'bg-white dark:bg-black text-black dark:text-white border-gray-200 dark:border-gray-700 disabled:opacity-50 disabled:cursor-not-allowed relative items-center border'
